import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {CrystalclearCustomerBackUrl} from "../config/crystalclear-customer-back-url";
import {Trader} from "../../model/customer/trader";

@Injectable({
  providedIn: 'root'
})
export class CustomerTraderService extends CommonCrudService<Trader> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearCustomerBackUrl.GET_CUSTOMER_TRADER_LIST,
      CrystalclearCustomerBackUrl.SAVE_CUSTOMER_TRADER,
      CrystalclearCustomerBackUrl.DELETE_CUSTOMER_TRADER);
  }

}
